import React, { Component } from 'react'
import { AddNewCallDiv, AvatarDiv, BreakBar, OnlineBtn, AvatarBreakDiv } from '../styles/dialpadstyle'
import { Button } from 'modules/theme'

export class CallBreakSelectTheme extends Component {
    render() {
        const { breakImg, breakName, breakText, breakTime, ButtonText, OnClickEvent } = this.props;
        return (
            <div style={{height: 360, display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <AddNewCallDiv>
                    <BreakBar>
                        <AvatarBreakDiv>
                            <img src={breakImg} />
                        </AvatarBreakDiv>
                        <h4>{breakName}</h4>
                        <h6>{breakText}</h6>
                        <h5>{breakTime}</h5>
                    </BreakBar>
                </AddNewCallDiv>
                <OnlineBtn>
                    <Button hoverColor='white' btnStyle="simple" size="small" onClick={OnClickEvent}>
                        {ButtonText}
                    </Button>
                </OnlineBtn>
            </div>
        )
    }
}

export default CallBreakSelectTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallBreakSelectTheme.js